<template>
  <component
    class="ocean-ui-common-block"
    :is="tagName || 'div'"
    :class="classes"
  >
    <slot></slot>
  </component>
</template>

<script>
import themeMixins from '../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['tagName'],
};
</script>

<style scoped lang="scss">
.ocean-ui-common-block {
  cursor: pointer;
}
</style>
